// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"120":"169ce676","359":"3d18e89b"}[chunkId] + ".chunk.css";
};